import React, { useContext, useEffect } from "react";
import ContentHeader from "../../../../reusableComponents/contentHeader/ContentHeader";
import { Step, StepLabel, Stepper } from "@mui/material";
import OfferDetails from "../../../../reusableComponents/offerManagement/offerDetails/OfferDetails";
import CustomButton from "../../../../reusableComponents/CustomButton";
import EmiPlans from "../../../../reusableComponents/offerManagement/emiPlans/emiPlans";
import OfferManagementOverview from "../../../../reusableComponents/offerManagement/offerManagementOverview/offerManagementOverview";
import { useLocation, useNavigate } from "react-router-dom";
import OfferManagementContext from "../../../../context/offerManagement.context";
import { isEmpty } from "../../../utils/utils";
import { customToast } from "../../../../reusableComponents/customToaster/customToast";
import SmallModal from "../../../../reusableComponents/modals/SmallModal";
import { useAuth } from "../../../../context/API_Client";
import "./createNoOrLowCostEmi.css";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { colorBrandObject } from "../../../../../constants/brandings";

export default function CreateNoOrLowCostEmi() {
  const steps = ["Offer Details", "EMI Plans", "Overview"];
  const { addEmiRule, updateEmiRule } = useAuth();
  const location = useLocation();
  const { type = 'create' } = location.state?.editData || {};
  const navigate = useNavigate();
  const {
    showModal,
    setShowModal,
    errorMsz,
    offerFieldData,
    setAllNoOrLowCostOffers,
    allNoOrLowCostOffers,
    setTotalDataCount,
    emiData,
    offerDetailsById,
    resetContext,
    setCallApi
  } = useContext(OfferManagementContext);
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const [isNextButtonDisabled, setIsNextButtonDisabled] = React.useState(true);
  const [isBtnLoading, setIsBtnLoading] = React.useState(false);

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };
  const transformDataToPayload = () => {
    let filteredData = emiData?.filter((row) => {
      const isOfferAlreadyActive = !isEmpty(row?.emiMethod?.applicableOffer) && offerDetailsById.code !== row?.emiMethod?.applicableOffer?.code;
      return row?.isChecked && !isOfferAlreadyActive
    });
    const now = new Date();
    const thirtySecLater = new Date(now.getTime() + (1 * 30 * 1000));
    let newStartDate = (offerFieldData?.offerStartDate && offerFieldData?.offerStartDate < now) ? thirtySecLater : offerFieldData?.offerStartDate;
    const minMoney = {
      currencyCode: offerFieldData?.currencySelected || null,
      amount: offerFieldData?.minAmount ? Number(offerFieldData.minAmount) : null,
    };
    const maxMoney = {
      currencyCode: offerFieldData?.currencySelected || null,
      amount: offerFieldData?.maxAmount ? Number(offerFieldData.maxAmount) : null,
    };
    const transformedData = {
      title: offerFieldData?.offerTitle,
      description: offerFieldData?.offerDescription,
      type: emiData[0].type,
      discount: {
        percentage: emiData[0]?.emiMethod?.merchantBorneInterestRate,
        type: emiData[0]?.offerType,
      },
      criteria: {
        startDate: offerFieldData.offerStartDate,
        // startDate: type === 'create' ? newStartDate : offerFieldData?.offerStartDate,
        endDate: offerFieldData?.offerEndDate,
        minMoney:
          minMoney.amount !== null && minMoney.currencyCode !== null
            ? minMoney
            : null,
        maxMoney:
          maxMoney.amount !== null && maxMoney.currencyCode !== null
            ? maxMoney
            : null,
        applicableTo: {
          paymentMethods: filteredData?.map((option) => (option?.isChecked && {
            type: option.type,
            brand: option?.brand,
            issuer: option?.emiMethod?.issuer,
            duration: option?.emiMethod?.duration,
            discount: {
              percentage: option?.emiMethod?.merchantBorneInterestRate,
              type: option?.offerType
            }
          })),
        },
      },
      enabled: true,
    };
    if (type === 'edit') {
      transformedData['version'] = offerDetailsById.version;
    }
    if ((type !== 'create' && transformedData.criteria.startDate < now) || offerFieldData.startImmediately) {
      delete transformedData.criteria.startDate
    }
    return transformedData;
  };
  const handleNext = () => {
    if (!isEmpty(errorMsz)) {
      setShowModal(true);
      return
    }
    if (activeStep === steps.length - 1) {
      setIsBtnLoading(true);
      const payload = transformDataToPayload();
      if (type === 'edit') {
        updateEmiRule(payload, offerDetailsById?.code, handleSuccess, handleError);
      } else {
        addEmiRule(payload, handleSuccess, handleError);
      }
      function handleSuccess(data) {
        setAllNoOrLowCostOffers(prev => ([data, ...prev]));
        setTotalDataCount(state => state + 1)
        // resetContext();
        setCallApi(false)
        setTimeout(() => {
          navigate("/offerManagement");
          setIsBtnLoading(false);
        }, 500);
        return
      }
      function handleError(errMsg) {
        setIsBtnLoading(false);
        customToast("error", "high", errMsg || "Something went wrong");
      }
      return
    }

    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };
  const handleCancel = () => {
    if (activeStep === 0) {
      resetContext();
      navigate("/offerManagement"); // replace "/your-desired-url" with your actual URL path 
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };
  const handleReset = () => {
    setActiveStep(0);
  };
  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return <OfferDetails setIsNextButtonDisabled={setIsNextButtonDisabled} setIsBtnLoading={setIsBtnLoading} />;
      case 1:
        return <EmiPlans setIsNextButtonDisabled={setIsNextButtonDisabled} />;
      case 2:
        return <OfferManagementOverview />;
      default:
        return null;
    }
  };
  const StepperIcon = (props) => {
    const { active, completed, icon } = props;
    return active ? (
      <CheckCircleIcon sx={{ color: colorBrandObject?.primaryButtonColor, fontSize: '30px' }} />
    ) : (
      <div className="stepperIcon"
        style={{
          backgroundColor: completed ? colorBrandObject?.primaryButtonColor : '#aaa'
        }}
      >
        {icon}
      </div>
    )
  }

  return (
    <>
      <div className="content-wrapper" style={{ backgroundColor: "white" }}>
        <section className="content">
          <div className="createNoOrLowCostOfferMainDiv">
            <ContentHeader
              firstHeading={type === 'edit' ? "Edit EMI Offer" : "Create No or Low Cost EMI Offers"}
              secondHeading="Kindly ensure that you have an agreement with your service provider before creating a No-Cost EMI"
              icon={<img src="/assets/offers/seal-question.svg" alt="offers" />}
            />
            <div style={{ margin: "28px 0px 32px 36px", width: "50%" }}>
              <Stepper activeStep={activeStep} >
                {steps.map((label, index) => {
                  const stepProps = {};
                  const labelProps = {};

                  if (isStepSkipped(index)) {
                    stepProps.completed = false;
                  }
                  return (
                    <Step key={label} {...stepProps}>
                      <StepLabel {...labelProps}
                        StepIconComponent={StepperIcon}
                      >{label}</StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
            </div>
            <div>
              {renderStepContent(activeStep)}
            </div>

            <div style={{ marginTop: 32, display: "flex", justifyContent: "end", gap: "8px" }}>
              <CustomButton
                variant={"outlined"}
                size={"md"}
                type={"primary"}
                text={activeStep === 0 ? "Cancel" : "Back"}
                onClick={handleCancel}
                disabled={isBtnLoading}
              />
              <CustomButton
                variant={"contained"}
                size={"md"}
                type={"primary"}
                loading={isBtnLoading}
                text={activeStep === steps.length - 1 ? (type === 'edit' ? 'Save Changes' : 'Create EMI Offer') : 'Next'}
                onClick={handleNext}
                disabled={isNextButtonDisabled || isBtnLoading}
              />
            </div>

            {activeStep === steps.length && (
              <div>
                <p>All steps completed - you're finished</p>
                <button onClick={handleReset}>
                  Reset
                </button>
              </div>
            )}
          </div>
        </section>

        {
          showModal && (
            <SmallModal
              headerText={"No issuer found"}
              subHeaderText={errorMsz}
              icon={<img src="/assets/infoIconForSmallModal.svg" />}
              toggleDialog={showModal}
              filledBtnText={"Got it"}
              filledBtnFunction={() => { setShowModal(false); }}
            />
          )
        }
      </div>
    </>
  );
}
